import {
  arrayOf,
  shape,
  string,
  number,
  instanceOf,
  oneOfType,
} from 'prop-types';

const selectedEntitiesPropType = arrayOf(
  shape({
    entity: shape({
      id: string.isRequired,
      type: string.isRequired,
    }),
    data: shape({
      periodKey: number.isRequired,
      value: number,
      date: instanceOf(Date).isRequired,
      percentage: number,
    }),
    breakdown: oneOfType([string, number]),
    countryId: string,
  }).isRequired
);

export default selectedEntitiesPropType;
